import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
import { SubscriptionType } from "enums/SubscriptionType";
import { PopupModal } from "react-calendly";
import { foodInfluencersCollabLink } from "helpers/calendly-helper";
import "./Paywall.scss";
import { isMobile } from "react-device-detect";

const FreemiumStickyBar: React.FC<{ height: number }> = ({ height }) => {
  const { subscription, business } = useSelector(
    (state: BusinessState) => state.business,
  );
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const freemium =
    subscription?.subscriptionType === SubscriptionType.Fremium;

  if (!freemium) return null;

  return (
    <>
      <div className={`freemium-bar ${isMobile ? "mobile" : ""}`} style={{ height: height }}>
        <FontAwesomeIcon icon={faPhone} className="icon" />
        <span className="text">
          Need help?{" "}
          <button
            type="button"
            className="cta"
            onClick={() => setIsOpen(true)}
          >
            Book A Call
          </button>
        </span>
      </div>

      <PopupModal
        url={foodInfluencersCollabLink}
        open={isOpen}
        onModalClose={() => setIsOpen(false)}
        rootElement={document.getElementById("root") as HTMLElement}
        prefill={{
          name: business?.contactPersonFullName || "",
          email: business?.contactPersonEmail || "",
          customAnswers: {
            a2: business?.businessName || "",
            a3: business?.venues?.[0]?.addressDisplay || "",
            a5:
              business?.venues?.[0]?.instagramUrl ||
              business?.venues?.[0]?.tiktokUrl ||
              "",
          },
        }}
      />
    </>
  );
};

export default FreemiumStickyBar;
